import { useEffect, useState } from "react";
import { TIndexLookUpApproach, TRecommendationType, TFundType } from "../types/newLinkBuilder";
import { TradedFundFilters } from "../types/newLinkBuilder";
import { httpClient } from "@/utils/api/client";

type UseFetchRecommendedTradedFundsProps = {
  searchValue: string;
  indexLookUpApproach: TIndexLookUpApproach;
  tradedFundFilters: TradedFundFilters;
  recommendationType: TRecommendationType;
  enabled?: boolean;
};

export const useFetchRecommendedTradedFunds = ({
  searchValue,
  indexLookUpApproach,
  tradedFundFilters,
  recommendationType,
  enabled = true,
}: UseFetchRecommendedTradedFundsProps) => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!searchValue.trim()) {
      setData([]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const queryType =
          indexLookUpApproach === TIndexLookUpApproach.RecommendationTool ? "company_name" : "fund_name";

        const isCompanyQuery = queryType === "company_name";

        const { data: result } = await httpClient.get("/search/fund-recommendation", {
          params: {
            query: searchValue,
            query_type: queryType,
            output_type: tradedFundFilters.fundType,
            region: tradedFundFilters.region,
            ...(isCompanyQuery ? { recommendation_type: recommendationType } : {}),
            ...(tradedFundFilters.fundType !== TFundType.Index ? { limit: tradedFundFilters.maxResults } : {}),
          },
          withCredentials: true,
        });

        setData(result || []);
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [searchValue, indexLookUpApproach, tradedFundFilters, recommendationType, enabled]);

  return { data, loading, error };
};
